/**
 * @module IDEE/style/form
 */

/**
 * Forma de estilo de círculo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CIRCLE = 'CIRCLE';

/**
 * Forma de estilo burbuja
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BUBBLE = 'BUBBLE';

/**
 * Forma de estilo de marcador.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const MARKER = 'MARKER';

/**
 * Forma de estilo de escudo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SHIELD = 'SHIELD';

/**
 * forma de estilo blasón.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BLAZON = 'BLAZON';

/**
 * forma de estilo triángulo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const TRIANGLE = 'TRIANGLE';

/**
 * forma de estilo de signo de advertencia.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SIGN = 'SIGN';

/**
 * Forma de estilo de prohibición.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BAN = 'BAN';

/**
 * Forma estilo rombo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const LOZENGE = 'LOZENGE';

/**
 * Forma de estilo cuadrado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SQUARE = 'SQUARE';

/**
 * Forma sin estilo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const NONE = 'none';

/**
 * Forma de estilo diamante.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const DIAMOND = 'DIAMOND';

/**
 * Forma de estilo puntero.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const POI = 'POI';

/**
 * Forma de estilo hexagono.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const HEXAGON = 'HEXAGON';

/**
 * Forma de estilo marcapaginas.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BOOKMARK = 'BOOKMARK';

/**
 * Forma de estilo coma.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const COMA = 'COMA';
